import { render, staticRenderFns } from "./CommercialProfile.vue?vue&type=template&id=044d64e8&"
import script from "./CommercialProfile.vue?vue&type=script&lang=js&"
export * from "./CommercialProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports